import { Observable } from "rxjs";
import { switchMap, catchError } from "rxjs/operators";

import { AuthServerProvider } from './auth.service';
import { LoginService } from "./login.service";
import { _throw } from "rxjs/observable/throw";
import { SnackBarService } from "../snackbar.service";
import { Injectable } from "@angular/core";

@Injectable()
export class Auth401Service {
    constructor(
        private authServerProvider: AuthServerProvider,
        private snackBarService: SnackBarService,
        private loginService: LoginService) { }

    handle401Error<T>(
        retryRequest: (jwtToken: string) => Observable<T>,
        originalError: any,
        wasLoggedIn: boolean,
        getPreviousJwtToken?: () => string,
        errorCallback?: () => void): Observable<T> {

        const currentJwtToken = this.authServerProvider.getToken();

        if (getPreviousJwtToken && (getPreviousJwtToken() !== currentJwtToken)) {
            return retryRequest(currentJwtToken);
        }

        if (!wasLoggedIn) {
            return this.fail(originalError, errorCallback);
        }

        return this.authServerProvider.refreshToken().pipe(
            switchMap((jwtToken: string) => {
                return retryRequest(jwtToken);
            }),
            catchError(error => this.sessionTimeoutFail(error, errorCallback)));
    }

    private sessionTimeoutFail(error: any, errorCallback?: () => void): Observable<any> {
        this.snackBarService.showMessage("Session has timed out. Please log in again.");
        return this.fail(error, errorCallback);
    }

    private fail(error: any, errorCallback?: () => void): Observable<any> {
        if (errorCallback) {
            errorCallback();
        }

        this.loginService.logout();
        return _throw(error);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/auth/auth401.service.ts